import React from "react";
import InputLabelDatePicker from "Components/Fragment/InputLabelDatePicker";
import { Box } from "Components/Base/Layout/Box";

const DateTimeField = ({ field, fieldState, disabled, onChange }) => {
  const { fieldError, fieldId, labelText, required, value } = fieldState;

  return (
    <Box mb={1.25}>
      <InputLabelDatePicker
        id={fieldId}
        label={labelText}
        name={labelText}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(field.id, event.target.value)}
        oldStyleLabel={true}
        required={required}
        nativeRequired={false}
        error={Boolean(fieldError)}
        helperText={fieldError}
      />
    </Box>
  );
};

export default DateTimeField;
